export const fetch_cloud_function = async (url_cloud_function, body_obj) => {
    try {
        let response = await fetch(url_cloud_function,
        {method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(
            body_obj
        )})
        let responseJSON = await response.json()
        if( responseJSON.success === true ){
            // console.log('fetch existoso')
            // console.log(responseJSON)
            return {success:true, response:responseJSON}
        }else{
            console.log('Ocurrio un error en fetch: ')
            console.log(responseJSON.message)
            return {success:false, response:null}
        }
    } catch (error) {
        console.log('Ocurrio un error en la funcion de fetch')
        console.log(error)
        return {success:false, response:null}
    }
}